/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { acceptShare } from '../fn/user-booking-shares-api/accept-share';
import { AcceptShare$Params } from '../fn/user-booking-shares-api/accept-share';
import { closeBox1 } from '../fn/user-booking-shares-api/close-box-1';
import { CloseBox1$Params } from '../fn/user-booking-shares-api/close-box-1';
import { deleteShare1 } from '../fn/user-booking-shares-api/delete-share-1';
import { DeleteShare1$Params } from '../fn/user-booking-shares-api/delete-share-1';
import { getBookingShare } from '../fn/user-booking-shares-api/get-booking-share';
import { GetBookingShare$Params } from '../fn/user-booking-shares-api/get-booking-share';
import { getBookingShareLogs } from '../fn/user-booking-shares-api/get-booking-share-logs';
import { GetBookingShareLogs$Params } from '../fn/user-booking-shares-api/get-booking-share-logs';
import { getBookingShares1 } from '../fn/user-booking-shares-api/get-booking-shares-1';
import { GetBookingShares1$Params } from '../fn/user-booking-shares-api/get-booking-shares-1';
import { getTowerInfo } from '../fn/user-booking-shares-api/get-tower-info';
import { GetTowerInfo$Params } from '../fn/user-booking-shares-api/get-tower-info';
import { getUserOpenTowers1 } from '../fn/user-booking-shares-api/get-user-open-towers-1';
import { GetUserOpenTowers1$Params } from '../fn/user-booking-shares-api/get-user-open-towers-1';
import { openBox1 } from '../fn/user-booking-shares-api/open-box-1';
import { OpenBox1$Params } from '../fn/user-booking-shares-api/open-box-1';
import { PageDtoBookingLogBookingLogDto } from '../models/page-dto-booking-log-booking-log-dto';
import { rejectShare } from '../fn/user-booking-shares-api/reject-share';
import { RejectShare$Params } from '../fn/user-booking-shares-api/reject-share';
import { ShareDto } from '../models/share-dto';
import { TowerSimpleDto } from '../models/tower-simple-dto';

@Injectable({ providedIn: 'root' })
export class UserBookingSharesApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `rejectShare()` */
  static readonly RejectSharePath = '/api/user/bookings/shares/{shareId}/reject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectShare()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectShare$Response(params: RejectShare$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return rejectShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rejectShare$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectShare(params: RejectShare$Params, context?: HttpContext): Observable<ShareDto> {
    return this.rejectShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `acceptShare()` */
  static readonly AcceptSharePath = '/api/user/bookings/shares/{shareId}/accept';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptShare()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptShare$Response(params: AcceptShare$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return acceptShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acceptShare$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptShare(params: AcceptShare$Params, context?: HttpContext): Observable<ShareDto> {
    return this.acceptShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `openBox1()` */
  static readonly OpenBox1Path = '/api/user/bookings/shares/{shareId}/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `openBox1()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox1$Response(params: OpenBox1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return openBox1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `openBox1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  openBox1(params: OpenBox1$Params, context?: HttpContext): Observable<void> {
    return this.openBox1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `closeBox1()` */
  static readonly CloseBox1Path = '/api/user/bookings/shares/{shareId}/close';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeBox1()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox1$Response(params: CloseBox1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return closeBox1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `closeBox1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  closeBox1(params: CloseBox1$Params, context?: HttpContext): Observable<void> {
    return this.closeBox1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBookingShares1()` */
  static readonly GetBookingShares1Path = '/api/user/bookings/shares';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShares1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares1$Response(params?: GetBookingShares1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareDto>>> {
    return getBookingShares1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShares1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShares1(params?: GetBookingShares1$Params, context?: HttpContext): Observable<Array<ShareDto>> {
    return this.getBookingShares1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShareDto>>): Array<ShareDto> => r.body)
    );
  }

  /** Path part for operation `getTowerInfo()` */
  static readonly GetTowerInfoPath = '/api/user/bookings/shares/{shareId}/tower';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTowerInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerInfo$Response(params: GetTowerInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<TowerSimpleDto>> {
    return getTowerInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTowerInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTowerInfo(params: GetTowerInfo$Params, context?: HttpContext): Observable<TowerSimpleDto> {
    return this.getTowerInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<TowerSimpleDto>): TowerSimpleDto => r.body)
    );
  }

  /** Path part for operation `getBookingShare()` */
  static readonly GetBookingSharePath = '/api/user/bookings/shares/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShare()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShare$Response(params: GetBookingShare$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareDto>> {
    return getBookingShare(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShare$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShare(params: GetBookingShare$Params, context?: HttpContext): Observable<ShareDto> {
    return this.getBookingShare$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShareDto>): ShareDto => r.body)
    );
  }

  /** Path part for operation `getBookingShareLogs()` */
  static readonly GetBookingShareLogsPath = '/api/user/bookings/shares/{id}/logs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBookingShareLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareLogs$Response(params: GetBookingShareLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoBookingLogBookingLogDto>> {
    return getBookingShareLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBookingShareLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBookingShareLogs(params: GetBookingShareLogs$Params, context?: HttpContext): Observable<PageDtoBookingLogBookingLogDto> {
    return this.getBookingShareLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoBookingLogBookingLogDto>): PageDtoBookingLogBookingLogDto => r.body)
    );
  }

  /** Path part for operation `getUserOpenTowers1()` */
  static readonly GetUserOpenTowers1Path = '/api/user/bookings/shares/tower/open';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserOpenTowers1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOpenTowers1$Response(params?: GetUserOpenTowers1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareDto>>> {
    return getUserOpenTowers1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserOpenTowers1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserOpenTowers1(params?: GetUserOpenTowers1$Params, context?: HttpContext): Observable<Array<ShareDto>> {
    return this.getUserOpenTowers1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShareDto>>): Array<ShareDto> => r.body)
    );
  }

  /** Path part for operation `deleteShare1()` */
  static readonly DeleteShare1Path = '/api/user/bookings/shares/{shareId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteShare1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare1$Response(params: DeleteShare1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteShare1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteShare1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteShare1(params: DeleteShare1$Params, context?: HttpContext): Observable<void> {
    return this.deleteShare1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
